import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const usePageTracking = () => {
  type trackingCodeType = '' | 'G-TGESGGG761';

  const location = useLocation();

  let trackingCode: trackingCodeType = 'G-TGESGGG761';

  useEffect(() => {
    ReactGA.initialize(trackingCode);
    ReactGA.send('pageview');
  }, [location, trackingCode]);
};

export default usePageTracking;
